import React from 'react';
import { Link } from 'react-router-dom';
import { UserMenu } from '../../AppWithAuth0.jsx';
import { useAuth } from '../../contexts/Auth0Context.jsx';
import { cn, getButtonClasses } from '../base-ui/baseUIConfig.js';

// hideLoginOnMobile: when true, the standalone Login button is hidden at mobile
// viewports (≤768 px). The caller is responsible for providing a consolidated
// CTA in the page body. This is gated via CSS so desktop behaviour is unchanged.
const SharedHeaderLayout = ({ children, hideLoginOnMobile = false }) => {
  const { user, loading, login } = useAuth();
  const navActionClasses = cn(
    getButtonClasses('primary', 'xs'),
    'text-[0.7rem] uppercase tracking-[0.08em]'
  );
  const secondaryActionClasses = cn(
    getButtonClasses('secondary', 'xs'),
    'text-[0.7rem] uppercase tracking-[0.08em]'
  );

  const handleLogin = () => {
    login({
      appState: {
        returnTo: `${window.location.pathname}${window.location.search || ''}`,
      },
    });
  };

  return (
    <header className="flex items-center justify-between border-b border-gaia-border bg-gaia-surface-raised px-3 py-2 shadow-lg shadow-black/20">
      <Link
        to="/"
        className="m-0 text-sm font-semibold uppercase tracking-[0.08em] text-gaia-primary transition-colors hover:text-gaia-primary-hover"
      >
        Fable Table
      </Link>

      <div className="flex gap-2 items-center">
        {children}
      </div>

      <div className="flex gap-3 items-center">
        <Link
          to="/about"
          className={navActionClasses}
        >
          About
        </Link>
        <Link
          to="/privacy"
          className={navActionClasses}
        >
          Privacy
        </Link>
        {!loading && !user && (
          <button
            type="button"
            onClick={handleLogin}
            data-testid="header-login-btn"
            className={cn(
              secondaryActionClasses,
              hideLoginOnMobile ? 'shared-header-login--hide-mobile' : ''
            )}
          >
            Login
          </button>
        )}
        <UserMenu />
      </div>
    </header>
  );
};

export default SharedHeaderLayout;
